import React from 'react';
import { ExternalToast, toast as sonnerToast } from 'sonner';
import { AlertProps } from '../components/Alert/Alert';
import { Toast } from '../components/Toast/Toast';

export type CustomToastOptions =
  | (Omit<AlertProps, 'children'> & Omit<ExternalToast, 'icon'> & { message: React.ReactNode })
  | string;

export const showToast = (options: CustomToastOptions) => {
  const { variant, title, message, icon, actions, loading, onClose, ...toastOptions } =
    typeof options === 'string' ? { message: options } : options;

  return sonnerToast.custom(
    (id) => (
      <Toast
        title={title}
        icon={icon}
        variant={variant}
        actions={actions}
        loading={loading}
        onClose={() => {
          onClose?.();
          sonnerToast.dismiss(id);
        }}
        message={message}
      />
    ),
    toastOptions
  );
};

// Basic usage: showSuccessToast({ message: "..." });
export const showSuccessToast = (options: CustomToastOptions) =>
  showToast({
    ...(typeof options === 'string' ? { message: options } : options),
    variant: 'success',
  });

export const showErrorToast = (options: CustomToastOptions) =>
  showToast({
    ...(typeof options === 'string' ? { message: options } : options),
    variant: 'error',
  });

export const showWarningToast = (options: CustomToastOptions) =>
  showToast({
    ...(typeof options === 'string' ? { message: options } : options),
    variant: 'warning',
  });

export const showInfoToast = (options: CustomToastOptions) =>
  showToast({ ...(typeof options === 'string' ? { message: options } : options), variant: 'info' });

export const dismissToast = sonnerToast.dismiss;
